import lozad from 'lozad'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const $body = $('body')
export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		const observer = lozad()
		observer.observe()

		if ($body.hasClass('tax-menu_categories') || $body.hasClass('page-template-menu')) {
			$('#menu-main-navigation #menu-item-96').addClass('current_page_item')
		}
	},
	finalize() {
		window.onload = onScroll
		window.onscroll = onScroll
		let $nav = $('#menu-menu-subnav')[0]
		let startingLocation =
			$nav.getBoundingClientRect().top +
			$nav.offsetHeight -
			document.body.getBoundingClientRect().top
		function onScroll() {
			if (!$nav) return
			
			if (window.pageYOffset > startingLocation) {
				if (!$nav.classList.contains('fixed')) {
					$nav.classList.toggle('fixed')
				}
			} else {
				$nav.classList.contains('fixed') && $nav.classList.toggle('fixed')
			}
		}

		let tl = gsap.timeline()
		gsap.from('h1', {
			y: 10,
			opacity: 0,
			delay: 1,
		})
		gsap.fromTo(
			'h2',
			{
				y: 10,
				opacity: 0,
			},
			{
				scrollTrigger: {
					trigger: 'h2',
					//toggleActions: 'play none none pause',
					// start: "+=50",
					// end:"+=700",
					// scrub: true
				},
				opacity: 1,
				y: 0,
				delay: 0,
				duration: 1,
				stagger: 1.5,
				ease: 'expo.easeOut',
			}
		)
		let $body = $('body')[0]
		if ($body.classList.contains('page-template-menu')) {
			// $('.menu-item').map(item =>
			gsap.fromTo(
				'.main-menu-item', //item,
				{
					// y: 10,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: '.main-menu-item', //item,
						//toggleActions: 'restart none none pause',
						// start: "+=50",
						// end:"+=700",
						// scrub: true
					},
					opacity: 1,
					// y: 0,
					delay: 0.5,
					duration: 1,
					stagger: 0.1,
					ease: 'expo.easeOut',
				}
			)
			//)
		}
		if ($body.classList.contains('page-template-wine-menu')) {
			document.querySelectorAll('.wine-menu-group h3').forEach((item) =>
				gsap.fromTo(
					item,
					{
						y: 10,
						opacity: 0,
					},
					{
						scrollTrigger: {
							trigger: item,
							//toggleActions: 'play none none pause',
							// start: "+=50",
							// end:"+=700",
							// scrub: true
						},
						opacity: 1,
						y: 0,
						delay: 0.35,
						duration: 1,
						stagger: 0.1,
						ease: 'expo.easeOut',
					}
				)
			)
			document.querySelectorAll('.wine-menu-item').forEach(
				(
					item //})
				) =>
					gsap.fromTo(
						item,
						{
							y: 10,
							opacity: 0,
						},
						{
							scrollTrigger: {
								trigger: item,
								//toggleActions: 'restart none none pause',
								// start: "+=50",
								// end:"+=700",
								// scrub: true
							},
							opacity: 1,
							y: 0,
							delay: 0.5,
							duration: 1,
							stagger: 0.1,
							ease: 'expo.easeOut',
						}
					)
			)
		}
		//! map
		document.querySelectorAll('.food-img').forEach((item) =>
			gsap.fromTo(
				item,
				{
					// y: 10,
					opacity: 0,
				},
				{
					scrollTrigger: {
						trigger: item,
						//toggleActions: 'restart none none pause',
						// start: "+=50",
						// end:"+=700",
						// scrub: true
					},
					opacity: 1,
					// y: 0,
					delay: 0.5,
					duration: 1,
					stagger: 1,
					ease: 'expo.easeOut',
				}
			)
		)
	},
}
